import { apiService } from '../api/api-client';
import { Settings, PrivateSettings } from '@/types';

export type InstrumentMapping = Record<string, string>;

class SettingsService {
  async getGlobalSettings(): Promise<Settings> {
    return apiService.get<Settings>('/settings/');
  }

  async getPrivateSettings(): Promise<PrivateSettings> {
    return apiService.get<PrivateSettings>('/settings/private/');
  }

  async getInstrumentMappings(counterparty: string): Promise<InstrumentMapping> {
    return apiService.get<InstrumentMapping>('/settings/instrument-mappings/', {
      params: { counterparty },
    });
  }
}

export const settingsService = new SettingsService();
